(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveController', ReserveController);

    ReserveController.$inject = ['$state', '$timeout', '$scope', 'entity', '$stateParams', 'OrderBag', 'OrderBagCustom', 'ServiceItemCustom', 'ServiceTimeSessionInfoCustom', 'ServiceTimeSession', 'CustomerCustom', 'Customer', 'Principal','$uibModal','$rootScope','CouponCustom','$window'];

    function ReserveController($state, $timeout, $scope, entity, $stateParams, OrderBag, OrderBagCustom, ServiceItemCustom, ServiceTimeSessionInfoCustom, ServiceTimeSession, CustomerCustom, Customer, Principal,$uibModal,$rootScope,CouponCustom,$window) {

        var vm = this;


        vm.scope = $scope;
        vm.orderBag = entity;
        vm.clear = clear;
        //vm.datePickerOpenStatus = {};
        //vm.openCalendar = openCalendar;
        vm.save = save;
        vm.reservesNum = [0];
        vm.computedFinalPrice = {};
        vm.hasMultipleReserveTime = false;
        vm.addReserveRow = addReserveRow;
        vm.removeReserveRow = removeReserveRow;
        //vm.serviceItems = ServiceItemCustom.getServiceItemsByCurrentCompany().query();
        //vm.selectedServiceItem = null;
        vm.serviceItem_changed = serviceItem_changed;
        vm.formState = "orderBagItem";
        vm.serviceSelected = serviceSelected;
        vm.findCustomer = findCustomer;
        // vm.getCompanyCustomersStatististics = getCompanyCustomersStatististics;
        vm.newCustomer = newCustomer;
        vm.newCustomerPopUp = newCustomerPopUp;
        vm.customerMode = "find";
        vm.findCustomerKeyPress = findCustomerKeyPress;
        vm.onItemChanged = onItemChanged;
        vm.onServiceChanged = onServiceChanged;

        vm.states = $stateParams;
        vm.formMode = 'new';
        vm.addNewCustomer = addNewCustomer ;
        vm.authorityRole = authorityRole;
        vm.hasCustomTime = false;
        vm.canSelectOtherServant = false;
        vm.mode = 'DEFAULT';
        vm.orderBag.checkCapacity = true;
        vm.closeModal = closeModal;
        vm.okModal = okModal;
        vm.orderBag.computeFinalPrice = true;
        vm.checkCouponCode = checkCouponCode;
        vm.couponCodeInput = '';
        vm.showUnPlannedTime = false;
        vm.searchCustomerByPhoneNumber = searchCustomerByPhoneNumber;

        Principal.hasAuthority("ROLE_CUSTOMER_MANAGER").then(function (has) {
            vm.isCustomerManager = has;
        });


        vm.selectedCustomerChanged = function (selectedItem) {
            if (selectedItem) {

                vm.selectedItem = selectedItem;
                var c = Customer.get({id: selectedItem.id});
                if (c != null) {
                    vm.orderBag.customer = c;
                    vm.existCustomerSearchResult = [];
                }
            }
        }
        vm.selectedCustomer = null;
        vm.searchCustomer = function (query) {
            return CustomerCustom.searchCustomerBySearch(query).query();
        }

        // function getCompanyCustomersStatististics(customer){
        //
        // }


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        load();

        function load() {
            vm.orderBag.orderBagServiceItems = [{}];
            if ($stateParams.serviceItemId != null && $stateParams.serviceItemId != undefined) {
                vm.formMode = 'fromURL'
            }
            if ($stateParams.customerId != null && $stateParams.customerId != undefined) {
                vm.formMode = 'fromURLCustomer'
                findCustomerById($stateParams.customerId).then(function (result) {

                    if (result != null) {
                        vm.orderBag.customer = result;
                    }
                });


            }

            if ($stateParams.hasCustomTime != null && $stateParams.hasCustomTime != undefined) {
                vm.hasCustomTime = $stateParams.hasCustomTime;
                vm.mode = 'CALENDAR_CUSTOM';
                if (vm.hasCustomTime == 'true')
                    vm.showUnPlannedTime = true;
            }

            if ($stateParams.canSelectOtherServant != null && $stateParams.canSelectOtherServant != undefined) {
                vm.canSelectOtherServant = $stateParams.canSelectOtherServant;
                vm.mode = 'CALENDAR_CUSTOM';
                if (vm.canSelectOtherServant == 'true')
                    vm.canSelectOtherServant = true;
                else
                    vm.canSelectOtherServant = false;
            }


        }


        function clear() {
            //$uibModalInstance.dismiss('cancel');
        }

        function addReserveRow() {

            var index = vm.orderBag.orderBagServiceItems.length;
            vm.orderBag.orderBagServiceItems.push({index: index, serviceTimeSession: {}})

            vm.hasMultipleReserveTime = true;

            if (vm.hasCustomTime)
                setDefaultTimesToNewItem();

            computeTotalPrice();
        }

        function removeReserveRow() {

            vm.orderBag.orderBagServiceItems.pop();
            computeTotalPrice();
        }

        function setDefaultTimesToNewItem() {
            var len = vm.orderBag.orderBagServiceItems.length;
            if (len > 1) {
                var lastItem = vm.orderBag.orderBagServiceItems[len - 1];
                var refItem = vm.orderBag.orderBagServiceItems[len - 2];

                lastItem.defaultStartDate = refItem.serviceTimeSession.endTime;

            }
        }

        function save() {

            //if(vm.scope.editForm.$valid) {
            var index = 0;
            if (vm.orderBag.orderBagServiceItems)
                angular.forEach(vm.orderBag.orderBagServiceItems, function (item) {
                    index++;
                    item.index = index;
                    if (item.serviceItemId)
                        item.serviceItem = {id: item.serviceItemId}

                })

            vm.isSaving = true;
            //if (vm.orderBag.id !== null) {
            OrderBagCustom.saveReserve().save(vm.orderBag, onSaveSuccess, onSaveError);
            //} else {
            //    OrderBag.save(vm.orderBag, onSaveSuccess, onSaveError);
            //}
            //}
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagUpdate', result);

            vm.isSaving = false;
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.close();
            }
            $state.transitionTo('supplierPanel.editOrderBag', {id: result.id});
        }

        function onItemChanged(newItem) {
                angular.forEach(vm.orderBag.orderBagServiceItems,function(item){
                    if(item.index==newItem.index)
                        item.serviceTimeSession=newItem.serviceTimeSession;
                })
            computeTotalPrice();
        }

        function onServiceChanged() {
            vm.orderBag.orderBagServiceItems.splice(1, vm.orderBag.orderBagServiceItems.length - 1);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function serviceItem_changed() {

        }

        function serviceSelected() {
            //  vm.formState = "orderBagItem";
        }

        function findCustomer() {

            vm.customerMode = "find";
            vm.orderBag.customer = {};
            if (vm.phoneNumberToFind != null && vm.phoneNumberToFind != undefined) {
                var c = CustomerCustom.getCustomerByPhoneNumber(vm.phoneNumberToFind).query();
                if (c != null) {
                    vm.orderBag.customer = c;
                }
            }
        }

        function newCustomer() {
            vm.phoneNumberToFind = "";
            vm.orderBag.customer = {};
            vm.customerMode = "new";
            vm.myRole = "ROLE_USER";
        }

        function newCustomerPopUp() {
            $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customer-pop-up.html',
                controller: 'CompanyCustomerPopUpController',
                controllerAs: 'vm',
                backdrop: 'true',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            // title: null,
                            // level: null,

                            id: null
                        };
                    }
                }
            }).result.then(function (v) {

                // var c = Customer.get({id: v.id});
                // if (c != null) {
                //     vm.orderBag.customer = c;
                // }
                vm.orderBag.customer = v.customer;
                //reload();
            }, function () {
                //nothing
            });
        }

        function findCustomerKeyPress(e) {
            if (e.keyCode === 13) {
                findCustomer();
                e.preventDefault();
                return false;
            }
            return true;
        }

        function findCustomerById(id) {
            return Customer.get({id: id}).$promise;
        }

        function authorityRole() {
            if (vm.customerMode == 'new') {
                return "ROLE_USER";
            } else {
                return "ROLE_CUSTOMER_MANAGER";
            }
        }

        function computeTotalPrice() {

            if (vm.mode == 'CALENDAR_CUSTOM') {
                OrderBagCustom.computeFinalPriceFixed().save(vm.orderBag, function (result) {
                    vm.computedFinalPrice = result;
                    vm.orderBag.checkCapacity = false;
                    vm.orderBag.computeFinalPrice = false;
                })
                return;
            }


            OrderBagCustom.computeFinalPrice().save(vm.orderBag, function (result) {
                vm.computedFinalPrice = result;
            })

            //if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined)
            //    return;
            //
            //var row;
            //var price = 0;
            //var discount = 0;
            //var vat = 0;
            //
            //var rowDiscount = 0;
            //var rowVat = 0;
            //var rowTotalPrice = 0;
            //
            //var subtotalService = 0;
            //var subtotalOptions = 0;
            //var subtotalDiscount = 0;
            //var subtotalVat = 0;
            //var finalPrice = 0;
            //var sumQty = 0;
            //
            //
            //if ($ctrl.settingInfo != null && $ctrl.settingInfo.financialSetting != null && $ctrl.settingInfo.financialSetting.taxPercentage != null) {
            //    vat = $ctrl.settingInfo.financialSetting.taxPercentage;
            //}
            //
            //
            //for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
            //
            //    row = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i];
            //    if (row.price != null)
            //        price = row.price;
            //    else
            //        price = 0
            //
            //    if (row.discount != null)
            //        discount = row.discount;
            //    else
            //        discount = 0
            //
            //    if (discount > 0) {
            //        rowDiscount = Math.round((discount * price / 100) * row.gty * $ctrl.timeUnitQty);
            //        row.totalPrice = (price * row.gty * $ctrl.timeUnitQty ) - rowDiscount;
            //    }
            //    else {
            //        rowDiscount = 0;
            //        row.totalPrice = price * row.gty * $ctrl.timeUnitQty;
            //    }
            //
            //    if (vat > 0) {
            //        rowVat = Math.round((row.totalPrice * vat) / 100);
            //        row.totalPrice = row.totalPrice + rowVat;
            //    }
            //
            //    sumQty += row.gty;
            //
            //    subtotalService = subtotalService + price * row.gty * $ctrl.timeUnitQty;
            //    subtotalDiscount = subtotalDiscount + rowDiscount;
            //    subtotalVat = subtotalVat + rowVat;
            //    rowTotalPrice = rowTotalPrice + row.totalPrice;
            //}
            //
            //$ctrl.orderBagServiceItem.subtotalOptionPrice = calculateOptionPrice(sumQty);
            //$ctrl.orderBagServiceItem.subtotalServicePrice = subtotalService;
            //$ctrl.orderBagServiceItem.subtotalVAT = subtotalVat;
            //$ctrl.orderBagServiceItem.subtotalDiscount = subtotalDiscount;
            //$ctrl.orderBagServiceItem.totalRowPrice = subtotalService + $ctrl.orderBagServiceItem.subtotalOptionPrice + subtotalVat - subtotalDiscount;

        }

        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }

        }

        function okModal() {
            save();

        }


        function addNewCustomer() {
            $uibModal.open({
                templateUrl: 'app/entities/company-customer/company-customers.html',
                controller: 'CompanyCustomerController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        return {
                            companyCustomer: null
                        };
                    }]
                }
            }).result.then(function (v) {
                vm.orderBag.customer = c;
            }, function () {
                //nothing
            });
        }

        function checkCouponCode() {

            if (vm.orderBag.couponToCheckValidity) {
                CouponCustom.evaluateCoupon().save(vm.orderBag, onCheckCouponSuccess, onCheckCouponError);

            }
        }

        function onCheckCouponSuccess(result) {


            if (result.resultStatus == 'DONE') {
                vm.couponResult = result;
                computeTotalPrice();
            }
        }

        function onCheckCouponError() {

            vm.couponResult = null;
            computeTotalPrice();
        }

        function searchCustomerByPhoneNumber() {

            if (!vm.orderBag.customer.personalInfo.phoneNumber || vm.orderBag.customer.personalInfo.phoneNumber.length < 6 || vm.orderBag.customer.personalInfo.phoneNumber.length == 11) {
                vm.existCustomerSearchResult = [];
                return;
            }

            CustomerCustom.searchCustomerBySearch(vm.orderBag.customer.personalInfo.phoneNumber).query().$promise.then(function (result) {
                vm.existCustomerSearchResult = result;
            });

        }

    }
})();
